(() => {
  if (window.aceK5ProductReady) return;
  window.aceK5ProductReady = true;
  const selector = 'hdt-quantity-wrapp[data-ace-quantity-owner]';
  const number = (value, fallback) => value != null && value !== '' && Number.isFinite(Number(value)) ? Number(value) : fallback;
  const ownerWrappers = owner => [...document.querySelectorAll(selector)].filter(w => w.dataset.aceQuantityOwner === owner);
  const validValue = (input, value) => {
    const min = number(input.min, 1);
    const max = number(input.max, Infinity);
    const step = number(input.step, 1) || 1;
    const clamped = Math.max(min, Math.min(max, value));
    return min + Math.max(0, Math.floor((clamped - min) / step)) * step;
  };
  const sync = source => {
    const wrapper = source?.closest(selector);
    if (!wrapper || source.value === '' || !Number.isFinite(Number(source.value))) return;
    const wrappers = ownerWrappers(wrapper.dataset.aceQuantityOwner);
    let value = validValue(source, Number(source.value));
    for (const peer of wrappers) {
      const input = peer.querySelector('input');
      if (input) value = Math.min(value, validValue(input, value));
    }
    for (const peer of wrappers) {
      const input = peer.querySelector('input');
      if (!input) continue;
      input.value = String(value);
      peer.validateQtyRules?.();
    }
  };
  for (const name of ['input', 'change', 'quantity-selector:update']) {
    document.addEventListener(name, event => {
      const wrapper = event.target.closest?.(selector);
      if (wrapper) queueMicrotask(() => sync(wrapper.querySelector('input')));
    }, true);
  }
  document.addEventListener('click', event => {
    const wrapper = event.target.closest?.(selector);
    // A task runs after native button handlers; a capture microtask can run before them.
    if (wrapper) setTimeout(() => sync(wrapper.querySelector('input')), 0);
  }, true);
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant) return;
    queueMicrotask(() => {
      const wrappers = [...document.querySelectorAll(selector)].filter(w => w.querySelector('input')?.form === event.target);
      const owners = new Set(wrappers.map(w => w.dataset.aceQuantityOwner));
      for (const owner of owners) {
        const peers = ownerWrappers(owner);
        for (const peer of peers) {
          const input = peer.querySelector('input');
          const rule = variant.quantity_rule || {};
          if (!input) continue;
          const stockMax = variant.inventory_management && variant.inventory_policy !== 'continue' && variant.inventory_quantity > 0 ? variant.inventory_quantity : Infinity;
          const ruleMax = number(rule.max, Infinity);
          const max = Math.min(stockMax, ruleMax);
          input.min = String(rule.min || 1);
          input.step = String(rule.increment || 1);
          if (Number.isFinite(max)) input.max = String(max); else input.removeAttribute('max');
        }
        if (peers.length) sync(peers[0].querySelector('input'));
      }
    });
  }, true);
  document.addEventListener('keydown', event => {
    const media = event.target.closest?.('.hdt-thumbnail__media[role="button"]');
    if (media && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      media.click();
    }
  });
  const routeHistory = () => {
    for (const picker of document.querySelectorAll('hdt-variant-picker[data-ace-product-id][update-url]')) {
      if (!picker.closest('[data-ace-main-product]')) continue;
      const old = picker.dataset.aceOriginalVariant;
      const selected = picker.dataset.aceSelectedVariant;
      const product = picker.dataset.aceProductId;
      const mapping = product === '7192267882555' ? {'41465261097019':'44422142525499','41465261129787':'44422142558267'} : product === '7192269226043' ? {'41465265094715':'44422143148091'} : {};
      const url = new URL(window.location.href);
      if (mapping[old] === selected && url.searchParams.get('variant') === old) {
        url.searchParams.set('variant', selected);
        history.replaceState(history.state, '', url);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', routeHistory, {once:true}); else routeHistory();
})();

/* ACE Rev37: small adapter for the Kalles native sticky purchase component. */
(() => {
  if (window.aceProductControlsReady) return;
  window.aceProductControlsReady = true;
  const findPicker = sticky => {
    const formId = sticky.getAttribute('form');
    return [...document.querySelectorAll('hdt-variant-picker[form]')].find(picker => picker.getAttribute('form') === formId);
  };
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-ace-sticky-select]');
    if (!select || !select.value) return;
    const sticky = select.closest('hdt-sticky-btn-atc');
    const picker = sticky && findPicker(sticky);
    if (picker?.selectVariantByID) picker.selectVariantByID(select.value, null, true);
  });
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    const sourceForm = event.target?.tagName === 'FORM' ? event.target : event.target?.form || event.target?.closest?.('form');
    for (const sticky of document.querySelectorAll('hdt-sticky-btn-atc')) {
      // A native form input named id shadows HTMLFormElement.id.
      if (sticky.getAttribute('form') !== sourceForm?.getAttribute('id')) continue;
      const select = sticky.querySelector('[data-ace-sticky-select]');
      if (select && variant) queueMicrotask(() => { select.value = String(variant.id); });
    }
  }, true);
})();

(() => {
  const enhance = () => {
    for (const trigger of document.querySelectorAll('[data-ace-quick-order-trigger]')) {
      if (trigger.dataset.aceLinked) continue;
      const list = document.getElementById(trigger.dataset.aceQuickOrderTrigger);
      if (!list) continue;
      const section = list.closest('.shopify-section');
      if (!section) continue;
      trigger.dataset.aceLinked = 'true';
      const sync = () => {
        section.hidden = !list.open;
        trigger.setAttribute('aria-expanded', String(list.open));
      };
      list.addEventListener('toggle', sync);
      sync();
      trigger.addEventListener('click', event => {
        event.preventDefault();
        section.hidden = false;
        list.open = true;
        sync();
        const summary = list.querySelector('summary');
        requestAnimationFrame(() => {
          list.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          summary?.focus({ preventScroll: true });
        });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();

/* Rev38: native dialog accessory traversal. */
(() => {
  let accessoryContext = null;
  const popupIds = new Set(['hdt-quick-view-modal','hdt-quick-add-modal']);
  const triggersForContext = () => accessoryContext?.isConnected
    ? [...accessoryContext.querySelectorAll('[data-ace-addon-view][handle]')]
    : [];
  const updateNavigation = dialog => {
    const product = dialog.querySelector('[data-ace-popup-product]');
    const navigation = dialog.querySelector('[data-ace-popup-addon-navigation]');
    if (!product || !navigation) return;
    const triggers = triggersForContext();
    const index = triggers.findIndex(trigger => trigger.getAttribute('handle') === product.dataset.acePopupProduct);
    navigation.hidden = index < 0 || triggers.length < 2;
    if (navigation.hidden) return;
    navigation.querySelector('[data-ace-popup-addon-position]').textContent = `${index + 1} / ${triggers.length}`;
    navigation.querySelector('[data-ace-popup-addon-step="-1"]').disabled = index === 0;
    navigation.querySelector('[data-ace-popup-addon-step="1"]').disabled = index === triggers.length - 1;
  };
  document.addEventListener('click', event => {
    const stepButton = event.target.closest('[data-ace-popup-addon-step]');
    if (stepButton) {
      const dialog = stepButton.closest('dialog');
      const product = dialog?.querySelector('[data-ace-popup-product]');
      if (!dialog || !product || stepButton.disabled) return;
      const triggers = triggersForContext();
      const current = triggers.findIndex(trigger => trigger.getAttribute('handle') === product.dataset.acePopupProduct);
      const next = triggers[current + Number(stepButton.dataset.acePopupAddonStep)];
      if (!next) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const originalClose = next.getAttribute('close-dialog');
      next.setAttribute('close-dialog', dialog.id);
      next.click();
      if (originalClose === null) next.removeAttribute('close-dialog');
      else next.setAttribute('close-dialog', originalClose);
      return;
    }
    const trigger = event.target.closest('[handle][aria-controls]');
    if (!trigger || !popupIds.has(trigger.getAttribute('aria-controls'))) return;
    accessoryContext = trigger.closest('[data-ace-product-addons]');
  }, true);
  document.addEventListener('dialog:opening', event => {
    if (popupIds.has(event.target.id)) updateNavigation(event.target);
  }, true);
})();

/* Rev41: Escape uses the native Share popup close action. */
(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const dialog = event.target.closest('.ace-product-share dialog[open]');
    const close = dialog?.querySelector('[ref="closeButton"]');
    if (!close) return;
    event.preventDefault();
    event.stopPropagation();
    close.click();
  }, true);
})();

/* Draft presentation only. Never replace native sharing handlers or data. */
(() => {
  if (window.aceJudgeMeXLabelsReady) return;
  window.aceJudgeMeXLabelsReady = true;

  const selector = '.jdgm-rev__share-twitter';
  let currentWidget = null;
  let observer = null;

  const label = element => {
    if (element.getAttribute('title') !== 'X') element.setAttribute('title', 'X');
    if (element.getAttribute('aria-label') !== 'Share on X') element.setAttribute('aria-label', 'Share on X');
  };
  const update = scope => {
    if (scope.matches?.(selector)) label(scope);
    for (const element of scope.querySelectorAll(selector)) label(element);
  };
  const setup = () => {
    const widget = document.getElementById('judgeme_product_reviews');
    if (widget === currentWidget) return;
    observer?.disconnect();
    observer = null;
    currentWidget = widget;
    if (!widget) return;

    update(widget);
    observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1) update(node);
        }
      }
    });
    // Label writes are attributes; only inserted children are observed.
    observer.observe(widget, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();


(() => {
  const grids = new Set();
  const widths = new WeakMap();
  let frame;
  const align = () => {
    frame = null;
    for (const grid of grids) {
      if (!grid.getBoundingClientRect().width) continue;
      grid.style.removeProperty('--ace-addon-price-height');
      grid.style.removeProperty('--ace-addon-rating-height');
      const prices = [...grid.querySelectorAll('.hdt-card-product__info > .hdt-price-wrapp')];
      const ratings = [...grid.querySelectorAll('.hdt-card-product__info > .ace-card-rating-slot')];
      const priceHeight = Math.ceil(Math.max(0, ...prices.map(e => e.getBoundingClientRect().height)));
      const ratingHeight = Math.ceil(Math.max(0, ...ratings.map(e => e.getBoundingClientRect().height)));
      grid.style.setProperty('--ace-addon-price-height', priceHeight + 'px');
      grid.style.setProperty('--ace-addon-rating-height', ratingHeight + 'px');
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const observer = new ResizeObserver(entries => {
    for (const {target, contentRect} of entries) {
      if (widths.get(target) !== contentRect.width) {
        widths.set(target, contentRect.width);
        schedule();
      }
    }
  });
  const setup = () => {
    document.querySelectorAll('.ace-addon-tab__grid').forEach(grid => {
      if (grids.has(grid)) return;
      grids.add(grid);
      observer.observe(grid);
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('click', event => { if (event.target.closest('.ace-product-tabs')) schedule(); });
  document.addEventListener('currency:update', schedule);
  document.addEventListener('shopify:section:load', setup);
  document.fonts?.ready.then(schedule);
})();
